import AlternateSalesAnalyticsPage from "pages/analytics/alternate-sales-analytics"
import DMCAnalyticsPage from "pages/analytics/dms-analytics.page"
import StockTakeAnalyticsPage from "pages/analytics/stock-take-analytics"
import React from "react"
import { VesaRouteType } from "routes"

const analyticsRoutes: VesaRouteType[] = [
  {
    path: "stock-take",
    permission: ["ds_view_stock_take_analytics"],
    element: <StockTakeAnalyticsPage />,
    icon: "send-to",
    title: "Stock Take Analytics",
  },
  {
    path: "dms",
    permission: ["ds_view_dms_analytics"],
    element: <DMCAnalyticsPage />,
    icon: "known-vehicle",
    title: "DMS Analytics",
  },
  {
    path: "alternate-sales",
    permission: ["ds_view_alternate_sales_analytics"],
    element: <AlternateSalesAnalyticsPage />,
    icon: "clipboard",
    title: "Alternate Sales Analytics",
  },
]

export default analyticsRoutes
